import CurrencyAmountsForm from './CurrencyAmountsForm';

export default CurrencyAmountsForm;
